class EmployeeFromCsvPayload {
  payload = new FormData();

  constructor(employeePayload = {}) {
    this.payload.append("csv", employeePayload.csvFile || null);
  }
}

export default EmployeeFromCsvPayload;
